import { getSessionValue } from '@mgm/common/utils';
import { TOKEN_KEY } from '../../data';

const getIdToken = (token?: string) => {
  if (token) return token;
  return getSessionValue(TOKEN_KEY, 'sessionStorage') as string;
};

export {
  getIdToken,
};
